<template>
  <div class="nav-list-group">
    <div
      class="nav-list-group__activator"
      :class="{ 'nav-list-group__activator--open': isOpen }"
      role="button"
      tabindex="0"
      :aria-expanded="isOpen ? 'true' : 'false'"
      @click="toggle"
      @keydown.enter.prevent="toggle"
      @keydown.space.prevent="toggle"
    >
      <span v-if="$slots.prepend || icon" class="nav-list-group__prepend">
        <slot name="prepend">
          <i v-if="icon" :class="icon"></i>
        </slot>
      </span>
      <span class="nav-list-group__title">{{ title }}</span>
      <span class="nav-list-group__arrow">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
        </svg>
      </span>
    </div>
    <transition name="expand">
      <div v-show="isOpen" class="nav-list-group__items">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'NavListGroup',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  // 하위 NavListItem 이 활성 상태가 되면 자신을 펼치도록 함수를 내려준다.
  provide() {
    return {
      navGroupActivate: () => {
        if (!this.isOpen) {
          this.isOpen = true
          this.$emit('update:modelValue', true)
        }
      }
    }
  },
  data() {
    return {
      isOpen: this.modelValue
    }
  },
  watch: {
    modelValue(val) {
      this.isOpen = val
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
      this.$emit('update:modelValue', this.isOpen)
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../scss/variables' as *;

.nav-list-group {
  &__activator {
    display: flex;
    align-items: center;
    min-height: 44px;
    padding: $spacing-2 $spacing-4;
    margin: 2px $spacing-2;
    border-radius: $radius-lg;
    cursor: pointer;
    transition: all $transition-fast;
    color: $color-text-primary;
    position: relative;

    &:hover {
      background-color: $color-gray-100;

      .nav-list-group__arrow {
        color: $color-primary;
      }
    }

    &--open {
      background-color: rgba($color-primary, 0.08);

      .nav-list-group__arrow {
        transform: rotate(180deg);
        color: $color-primary;
      }

      .nav-list-group__title {
        color: $color-primary;
        font-weight: $font-weight-semibold;
      }

      .nav-list-group__prepend {
        color: $color-primary;
      }
    }
  }

  &__prepend {
    display: flex;
    align-items: center;
    margin-right: $spacing-3;
    color: $color-text-secondary;
    font-size: 1.25rem;
    transition: color $transition-fast;
  }

  &__title {
    flex: 1;
    font-size: 15px;
    font-weight: $font-weight-medium;
    transition: all $transition-fast;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  &__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: $radius-sm;
    background-color: $color-gray-100;
    color: $color-text-secondary;
    transition: all $transition-normal;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  &__items {
    padding-left: $spacing-4;
    overflow: hidden;
    position: relative;

    // 서브메뉴 영역 왼쪽 라인 표시
    &::before {
      content: '';
      position: absolute;
      left: 24px;
      top: 4px;
      bottom: 4px;
      width: 2px;
      background-color: $color-gray-200;
      border-radius: 1px;
    }
  }
}

// Expand animation
.expand-enter-active,
.expand-leave-active {
  transition: all $transition-normal;
  max-height: 500px;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
